import { lazy } from 'react'

import { RouteConfig } from 'packages/route'

/**
 * 获取路由
 *
 * @returns 路由配置
 */
export const getRoutes: () => RouteConfig[] = () => [
  {
    path: '/',
    name: 'ActivityHome',
    getTitle: () => '首页',
    component: lazy(() =>
      import('./Home').then((m) => ({
        default: m.ActivityHome,
      }))
    ),
  },
]
